/* eslint-disable @repo/internal/react/no-css-string-literals */
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';

import { B400, N0, N30, N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export type Background = 'white' | 'blue' | 'neutral' | 'checkered';

const getBackgroundColor = (code: Background | undefined): SerializedStyles => {
  switch (code) {
    case 'white':
      return css`
        background-color: ${token('elevation.surface', N0)};
      `;

    case 'blue':
      return css`
        background-color: ${token('color.background.brand.bold', B400)};
      `;

    case 'neutral':
      return css`
        background-color: ${token('color.background.neutral.hovered', N40)};
      `;

    default:
    case 'checkered':
      return css`
        background-color: ${token('elevation.surface', N0)};
        background-image: linear-gradient(
            45deg,
            ${token('elevation.surface.sunken', '#f9f9fa')} 25%,
            transparent 25%
          ),
          linear-gradient(
            135deg,
            ${token('elevation.surface.sunken', '#f9f9fa')} 25%,
            transparent 25%
          ),
          linear-gradient(
            45deg,
            transparent 75%,
            ${token('elevation.surface.sunken', '#f9f9fa')} 75%
          ),
          linear-gradient(
            135deg,
            transparent 75%,
            ${token('elevation.surface.sunken', '#f9f9fa')} 75%
          );
      `;
  }
};

export type ExampleShowcaseProps = {
  backgroundColor?: Background;
};

/**
 * __Example showcase__
 *
 * An example showcase displays an example with code and link to codesandbox.
 *
 */
const ExampleShowcase = styled.div<ExampleShowcaseProps>`
  padding: ${token('space.300', '24px')};
  ${({ backgroundColor }: any) => getBackgroundColor(backgroundColor)}
  background-size: 20px 20px;
  background-position: 0 0, 10px 0, 10px -10px, 0px 10px;
  border-radius: ${token('border.radius', '3px')}
    ${token('border.radius', '3px')} 0 0;
  border-bottom: ${token('border.width', '1px')} solid
    ${token('color.border', N30)};
`;

export default ExampleShowcase;
